"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTrendsChartGroupNewState = exports.defaultTrendsChartGroupNewState4 = exports.defaultTrendsChartGroupNewState3 = exports.defaultTrendsChartGroupNewState2 = exports.defaultTrendsChartGroupNewState1 = void 0;
var ChartGroupNewType_1 = require("@/pages/common/states/ChartGroupNewType");
var ChartState_init_1 = require("@/pages/common/states/ChartState.init");
exports.defaultTrendsChartGroupNewState1 = {
    title: 'Price',
    type: ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT,
    active: true,
    charts: ChartState_init_1.defaultChartStatePrice
};
exports.defaultTrendsChartGroupNewState2 = {
    title: 'Transaction Amount',
    type: ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT,
    active: false,
    charts: ChartState_init_1.defaultChartStateAmount
};
exports.defaultTrendsChartGroupNewState3 = {
    title: 'Price Range',
    type: ChartGroupNewType_1.ChartGroupNewType.PRICERANGE,
    active: false,
    charts: ChartState_init_1.defaultChartStatePriceRange
};
exports.defaultTrendsChartGroupNewState4 = {
    title: 'Transactions by Price Range',
    type: ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE,
    active: false,
    charts: ChartState_init_1.defaultChartStateTransactionByPriceRange
};
exports.defaultTrendsChartGroupNewState = [
    exports.defaultTrendsChartGroupNewState1,
    exports.defaultTrendsChartGroupNewState2,
];
